<template>
  <p v-if="tickets.length == 0" class="py-10 text-2xl text-center text-gray-400">No Closed Tickets</p>

  <router-link v-else v-for="ticket in tickets" :key="ticket.id" :to="{ name: 'TicketsShow', params: {id: ticket.id} }">
    <div class="p-3 mt-2 bg-white rounded-lg shadow">
      <div class="flex justify-between">
        <div>
          <p class="text-sm font-medium leading-none text-gray-500">{{ ticket.category.scope }}</p>
          <p class="mt-1 font-medium leading-none text-gray-500">{{ ticket.category.name }}</p>
        </div>

        <div class="text-sm leading-none">
          <p class="font-thin text-right text-gray-500 capitalize">#{{ ticket.id }}</p>
          <p class="mt-1 font-thin capitalize" :class="{ 'text-green-500': ticket.status == 'resolved', 'text-orange-500': ticket.status == 'closed' }">{{ ticket.status }}</p>
        </div>
      </div>

      <p class="mt-2 text-gray-700">{{ ticket.description }}</p>

      <div v-if="ticket.owner || ticket.last_message" class="flex justify-between mt-2 text-sm text-gray-500">
        <p v-if="ticket.owner" class="leading-none">Handled by <b class="text-gray-700">{{ ticket.owner.name }}</b></p>
        <p v-if="ticket.last_message" class="leading-none">Last Reply <b class="text-gray-700">{{ toDate(ticket.last_message.created_at) }}</b></p>
      </div>

      <p class="mt-2 text-gray-700">
        <span class="text-sm leading-none text-gray-500">Resolution:</span> {{ ticket.resolution }}
      </p>
    </div>
  </router-link>
</template>

<script>
import mixin from '@/utils/mixin';

export default {
  name: 'TicketsClosedTickets',
  mixins: [ mixin ],
  props: {
    tickets: {
      type: Array,
      required: true,
    },
  },
}
</script>
